import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
}

export const useSendAllDeclarationsToPlda = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId }: HookProps) => {
      await request({
        path: `batches/${batchId}/send-declarations-to-plda`,
        method: 'POST',
        authenticate: true,
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['batch', variables.batchId] });
      toast.success('Started sending all declarations!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error sending all declarations!');
    },
  });
};
